import {
    Box,
    Button,
    IconButton,
    Tooltip,
    Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import InfoIcon from "@material-ui/icons/Info";
import { styled } from "@mui/material/styles";
import { tooltipClasses } from "@mui/material/Tooltip";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const checkLength = (multiLine) => {
    let msgLength = 0;
    Object.entries(multiLine).map(([key, value]) => {
        key = { key };
        msgLength += value.length;
    });
    return msgLength >= 150;
};

const useStyles = makeStyles((theme) => ({
    boxToolTip: {
        backgroundColor: "#f5f5f9",
        color: "rgba(0, 0, 0, 0.87)",
        border: "1px solid #dadde9",
        padding: "10px",
    },
    colorInherit: {
        color: "#333 !important",
        marginTop: "-3px",
    },
    whiteIcon: {
        color: "#fff !important",
        marginTop: "-3px",
    },
    maxContent: {
        [`& .${tooltipClasses.tooltip}`]: {
            maxWidth: "800px",
        },
    },
}));

function CustomTooltip({
    boxToolTip = false,
    title = null,
    multiLine = null,
    width = 220,
    icon = null,
    titleJustify = null,
    whiteIcon = false,
    needLabel = true,
    maxContent = false,
}) {
    const HtmlTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: "#f5f5f9",
            color: "rgba(0, 0, 0, 0.87)",
            maxWidth: width,
            border: "1px solid #dadde9",
        },
    }));

    const { t, i18n } = useTranslation();
    const [open, setOpen] = useState(false);
    const [tipsOpen, setTipsOpen] = useState(false);
    const [titleJustifyOpen, setTitleJustifyOpen] = useState(false);
    const [boxToolTipOpen, setBoxToolTipOpen] = useState(false);

    const [bigToolTip, setBigToolTip] = useState(false);
    const classes = useStyles();

    const handleTooltipClose = () => {
        setOpen(false);
    };

    const handleTooltipOpen = () => {
        setOpen(true);
    };

    return (
        <>
            {title ? (
                <Tooltip
                    disableHoverListener={true}
                    // onClose={(e) => {
                    //     console.log("aaaaa");
                    //     setTipsOpen(false);
                    // }}
                    open={tipsOpen}
                    title={<Typography color="inherit">{title}</Typography>}
                    style={{ maxWidth: "500px" }}
                    classes={maxContent ? { popper: classes.maxContent } : {}}
                >
                    {icon == null ? (
                        <Button
                            tabIndex="0"
                            style={
                                needLabel
                                    ? {
                                          padding: 0,
                                          textTransform: "none",
                                      }
                                    : {
                                          padding: 0,
                                          textTransform: "none",
                                          minWidth: "0",
                                      }
                            }
                            onClick={(e) => {
                                setTipsOpen(!tipsOpen);
                                e.stopPropagation();
                            }}
                        >
                            <InfoIcon
                                className={
                                    whiteIcon
                                        ? classes.whiteIcon
                                        : classes.colorInherit
                                }
                            />
                            {needLabel ? (
                                <span>{t("common.information")}</span>
                            ) : null}
                        </Button>
                    ) : (
                        icon
                    )}
                </Tooltip>
            ) : null}
            {titleJustify ? (
                <Tooltip
                    open={titleJustifyOpen}
                    // onClose={() => {
                    //     setTitleJustifyOpen(false);
                    // }}
                    title={
                        <Typography color="inherit" align="justify">
                            {titleJustify}
                        </Typography>
                    }
                    //disableInteractive={false}
                >
                    {icon == null ? (
                        <Button
                            style={{ padding: 0, textTransform: "none" }}
                            onClick={(e) => {
                                setTitleJustifyOpen(!titleJustifyOpen);
                            }}
                        >
                            <InfoIcon className={classes.colorInherit} />
                            {needLabel ? (
                                <span>{t("common.information")}</span>
                            ) : null}
                        </Button>
                    ) : (
                        icon
                    )}
                </Tooltip>
            ) : null}
            {multiLine ? (
                // checkLength(multiLine) ||
                boxToolTip ? (
                    <React.Fragment>
                        <Tooltip
                            open={open}
                            onOpen={handleTooltipOpen}
                            onClose={handleTooltipClose}
                            title={t("common.toolTip.hint")}
                            // disableInteractive={false}
                        >
                            <IconButton
                                onClick={() => {
                                    if (bigToolTip) {
                                        setBigToolTip(false);
                                    } else {
                                        setBigToolTip(true);
                                    }
                                }}
                            >
                                {icon == null ? (
                                    <>
                                        <InfoIcon
                                            style={{
                                                textTransform: "none",
                                            }}
                                            className={classes.colorInherit}
                                        />
                                        <span style={{ fontSize: "0.875rem" }}>
                                            {t("common.information")}
                                        </span>
                                    </>
                                ) : (
                                    icon
                                )}
                            </IconButton>
                        </Tooltip>
                        {bigToolTip
                            ? Object.entries(multiLine).map(([key, value]) => {
                                  return (
                                      <Typography
                                          className={classes.boxToolTip}
                                          key={key}
                                      >
                                          {value}
                                      </Typography>
                                  );
                              })
                            : null}
                    </React.Fragment>
                ) : (
                    <Tooltip
                        open={boxToolTipOpen}
                        // onClose={() => {
                        //     setBoxToolTipOpen(false);
                        // }}
                        title={
                            <Typography color="inherit">
                                {Object.values(multiLine).map((item, index) => (
                                    <Box key={index}>{item}</Box>
                                ))}
                            </Typography>
                        }
                        // disableInteractive={false}
                    >
                        {icon == null ? (
                            <Button
                                style={{ padding: 0, textTransform: "none" }}
                                onClick={(e) => {
                                    setBoxToolTipOpen(!boxToolTipOpen);
                                }}
                            >
                                <InfoIcon />
                                {needLabel ? (
                                    <span>{t("common.information")}</span>
                                ) : null}
                            </Button>
                        ) : (
                            icon
                        )}
                    </Tooltip>
                )
            ) : null}
        </>
    );
}

// function compare(prevProps, props) {
//     return (
//         prevProps.boxToolTip === props.boxToolTip &&
//         prevProps.width === props.width &&
//         equarComplex(prevProps.title, prevProps.title) &&
//         equarComplex(prevProps.multiLine, props.multiLine)
//     );
// }

// export default React.memo(CustomTooltip, compare);
export default CustomTooltip;
